export const CalculateBMI = (size_ft, size_in, weight) => {
	const new_ft = size_ft * 12;
	const height = new_ft + parseInt(size_in);
	const bodyMassDO = ((weight / height ** 2) * 703).toFixed(2);
	return bodyMassDO;
};
